module.exports = __webpack_public_path__ + "static/media/dailekh4.a4f4bf15.ogg";